import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { defaultLocale } from '../../intl';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

import { LANGUAGE_KEY } from '../../helpers/languages';

import css from './MultiLanguageSelect.module.css';

const MultiLanguageSelectComponent = props => {
  const { onUpdateProfile, currentUser } = props;

  const currentLocale = typeof window !== 'undefined' && window.localStorage.getItem(LANGUAGE_KEY) || defaultLocale;


  //set language to saved value if any
  useEffect(() => {
    const savedLanguageMaybe =
      currentUser?.attributes?.profile?.publicData?.language ||
      window.localStorage.getItem(LANGUAGE_KEY) || currentLocale;

    if (currentLocale !== savedLanguageMaybe) {
      window.localStorage.setItem(LANGUAGE_KEY, currentUser?.attributes?.profile?.publicData?.language);
    }
  }, []);

  const handleLanguageSwitch = async (lang) => {

    if (currentUser?.id?.uuid) {
      await onUpdateProfile({
        publicData: {
          language: lang,
        },
      });
    }

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LANGUAGE_KEY, lang);
    }

    if (typeof document !== 'undefined') {
      document.location.reload(true);
    }
  };

  return (
    <div className={css.langSwitchWrapper}>

        <ul className={css.langSwitchContent}>
          <li
            className={classNames(css.labelWrapper, { [css.labelWrapperActive]: currentLocale === 'de' })}
            onClick={() => handleLanguageSwitch('de')}
          >
            <span className={css.label}>
              DE
            </span>
          </li>
          <li className={classNames(css.labelWrapper, css.labelSeparator)} />
          <li
            className={classNames(css.labelWrapper, { [css.labelWrapperActive]: currentLocale === 'en' })}
            onClick={() => handleLanguageSwitch('en')}
          >
            <span className={css.label}>
              EN
            </span>
          </li>
        </ul>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const MultiLanguageSelect = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(MultiLanguageSelectComponent);

export default MultiLanguageSelect;
